import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * OnboardingRoute - 確保用戶按順序完成 onboarding 步驟
 * 檢查 localStorage 中的進度，阻止用戶跳過步驟
 */
function OnboardingRoute({ children, step }) {
  // 檢查每個步驟所需的 localStorage 數據
  const checkStepCompletion = (stepNumber) => {
    switch (stepNumber) {
      case 1:
        // Step 1 是起點，總是可以訪問
        return true;
      case 2:
        // Step 2 需要完成 Step 1
        return localStorage.getItem('onboarding_step1_completed') === 'true';
      case 3:
        // Step 3 需要 Step 2 的 purposes (允許單數或複數)
        return localStorage.getItem('onboarding_purposes') !== null || localStorage.getItem('onboarding_purpose') !== null;
      case 4:
        // Step 4 需要 Step 3 的 formats
        const formats = localStorage.getItem('onboarding_tone_styles');
        return formats !== null && JSON.parse(formats).length > 0;
      case 5:
        // Step 5 需要 Step 4 的 excluded_theme（分析模式）或 target_theme（手動輸入）
        const excludedTheme = localStorage.getItem('onboarding_excluded_theme');
        const targetTheme = localStorage.getItem('onboarding_target_theme');
        return (
          excludedTheme !== null ||
          (targetTheme !== null && targetTheme.trim().length > 0)
        );
      case 6:
        // Step 6 需要 Step 5 的 reference_accounts（可以是空陣列）
        return localStorage.getItem('onboarding_reference_accounts') !== null;
      default:
        return false;
    }
  };

  // 檢查當前步驟是否可以訪問
  const canAccessStep = checkStepCompletion(step);

  if (!canAccessStep) {
    // 找出用戶應該在的步驟（找到第一個未完成的步驟）
    let redirectStep = 1;
    for (let i = 1; i < step; i++) {
      if (checkStepCompletion(i + 1)) {
        redirectStep = i + 1;
      } else {
        break;
      }
    }

    console.log(`[OnboardingRoute] Blocking access to step ${step}, redirecting to step ${redirectStep}`);
    return <Navigate to={`/onboarding/step${redirectStep}`} replace />;
  }

  return children;
}

export default OnboardingRoute;
